// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddAudio.module.css */
.AddAudios_container__7tw1K {
    background-color: #121212;
    color: #ffffff;
    padding: 2rem;
    min-height: 100vh;
  }
  
  .AddAudios_header__tWNPE {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }
  
  .AddAudios_headerIcon__LwFyF {
    color: #ff4444;
    width: 32px;
    height: 32px;
  }
  
  .AddAudios_header__tWNPE h1 {
    color: #ffffff;
    font-size: 2rem;
  }
  
  .AddAudios_form__ZcF3L {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .AddAudios_formGroup__1mdJ- {
    margin-bottom: 1.5rem;
  }
  
  .AddAudios_formGroup__1mdJ- label {
    display: block;
    margin-bottom: 0.5rem;
    color: #ffffff;
  }
  
  .AddAudios_formGroup__1mdJ- input[type="text"],
  .AddAudios_formGroup__1mdJ- textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #333;
    border-radius: 4px;
    background-color: #1e1e1e;
    color: #ffffff;
    font-size: 1rem;
  }
  
  .AddAudios_formGroup__1mdJ- input[type="text"]:focus,
  .AddAudios_formGroup__1mdJ- textarea:focus {
    outline: none;
    border-color: #ff444400;
  }
  
  .AddAudios_imageUploadSection__ksUrr {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-bottom: 2rem;
  }
  
  @media (min-width: 768px) {
    .AddAudios_imageUploadSection__ksUrr {
      grid-template-columns: 1fr 1fr;
    }
  }
  
  .AddAudios_imageUpload__Cx9cD, .AddAudios_audioUpload__3epvC {
    background-color: #1e1e1e;
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 2rem;
  }
  
  .AddAudios_uploadArea__QcG2- {
    min-height: 200px;
    border: 2px dashed #333;
    border-radius: 4px;
    position: relative;
  }
  
  .AddAudios_uploadPlaceholder__0dT7n {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    cursor: pointer;
    color: #888;
  }
  
  .AddAudios_uploadPlaceholder__0dT7n:hover {
    color: #ff4444;
  }
  
  .AddAudios_uploadPlaceholder__0dT7n svg {
    width: 48px;
    height: 48px;
    margin-bottom: 1rem;
  }
  
  .AddAudios_fileInput__uT8Kp {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  
  .AddAudios_imagePreview__Jxy4R {
    position: relative;
    height: 200px;
  }
  
  .AddAudios_imagePreview__Jxy4R img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
  
  .AddAudios_audioPreview__y67zQ {
    position: relative;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background-color: #252525;
    border-radius: 4px;
  }
  
  .AddAudios_removeButton__jyqLK {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #ffffff;
  }
  
  .AddAudios_removeButton__jyqLK:hover {
    background-color: #ff4444;
  }
  
  .AddAudios_checkboxLabel__ErsyB {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }
  
  .AddAudios_checkboxLabel__ErsyB input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #ff4444;
  }
  
  .AddAudios_submitButton__EVzg9 {
    background-color: #ff4444;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    padding: 1rem 2rem;
    font-size: 1rem;
    cursor: pointer;
    width: 100%;
    margin-top: 2rem;
    transition: background-color 0.2s;
  }
  
  .AddAudios_submitButton__EVzg9:hover {
    background-color: #ff2222;
  }
  
  .AddAudios_select__vl9J9 {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #333;
    border-radius: 4px;
    background-color: #1e1e1e;
    font-size: 1rem;
    color: white;
  }
  
  .AddAudios_select__vl9J9:focus {
    outline: none;
    border-color: #ff4444;
    box-shadow: 0 0 0 2px rgba(255, 68, 68, 0.25);
  }
  /* Searchable Select Wrapper */
.AddAudios_searchableSelect__GUWHn {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.AddAudios_searchableSelect__GUWHn:hover {
  border-color: #ff3333;
}

.AddAudios_searchableSelect__GUWHn input {
  flex-grow: 1;
  background: transparent;
  border: none;
  color: #f0f0f0;
  font-size: 1rem;
  outline: none;
  width: 100%;
}

.AddAudios_searchableSelect__GUWHn .AddAudios_dropdownArrow__Pky7X {
  margin-left: 8px;
  font-size: 14px;
  color: #ff6666;
  transition: transform 0.2s ease;
}

.AddAudios_searchableSelect__GUWHn.AddAudios_open__ZmpCF .AddAudios_dropdownArrow__Pky7X {
  transform: rotate(180deg);
}

/* Dropdown List */
.AddAudios_dropdownList__GqyZs {
 background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  margin-top: 5px;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: AddAudios_fadeIn__Pg284 0.2s ease-in-out;
}

.AddAudios_dropdownItem__T1ydQ {
  padding: 10px 14px;
  font-size: 1rem;
  color: #f0f0f0;
  transition: background 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.AddAudios_dropdownItem__T1ydQ:hover {
  background-color: #ff3333;
  color: #ffffff;
}

.AddAudios_dropdownItem__T1ydQ:empty {
  color: #888888;
  text-align: center;
}

.AddAudios_dropdownList__GqyZs::-webkit-scrollbar {
  width: 6px;
}

.AddAudios_dropdownList__GqyZs::-webkit-scrollbar-thumb {
  background: #ff3333;
  border-radius: 4px;
}

.AddAudios_dropdownList__GqyZs::-webkit-scrollbar-track {
  background: #222222;
}

@keyframes AddAudios_fadeIn__Pg284 {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/Audios/AddAudios.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE;MACE,8BAA8B;IAChC;EACF;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,6CAA6C;EAC/C;EACA,8BAA8B;AAChC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;CACC,yBAAyB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,mDAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* AddAudio.module.css */\n.container {\n    background-color: #121212;\n    color: #ffffff;\n    padding: 2rem;\n    min-height: 100vh;\n  }\n  \n  .header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .headerIcon {\n    color: #ff4444;\n    width: 32px;\n    height: 32px;\n  }\n  \n  .header h1 {\n    color: #ffffff;\n    font-size: 2rem;\n  }\n  \n  .form {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .formGroup {\n    margin-bottom: 1.5rem;\n  }\n  \n  .formGroup label {\n    display: block;\n    margin-bottom: 0.5rem;\n    color: #ffffff;\n  }\n  \n  .formGroup input[type=\"text\"],\n  .formGroup textarea {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #333;\n    border-radius: 4px;\n    background-color: #1e1e1e;\n    color: #ffffff;\n    font-size: 1rem;\n  }\n  \n  .formGroup input[type=\"text\"]:focus,\n  .formGroup textarea:focus {\n    outline: none;\n    border-color: #ff444400;\n  }\n  \n  .imageUploadSection {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    margin-bottom: 2rem;\n  }\n  \n  @media (min-width: 768px) {\n    .imageUploadSection {\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n  \n  .imageUpload, .audioUpload {\n    background-color: #1e1e1e;\n    border-radius: 8px;\n    padding: 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .uploadArea {\n    min-height: 200px;\n    border: 2px dashed #333;\n    border-radius: 4px;\n    position: relative;\n  }\n  \n  .uploadPlaceholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 200px;\n    cursor: pointer;\n    color: #888;\n  }\n  \n  .uploadPlaceholder:hover {\n    color: #ff4444;\n  }\n  \n  .uploadPlaceholder svg {\n    width: 48px;\n    height: 48px;\n    margin-bottom: 1rem;\n  }\n  \n  .fileInput {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n  }\n  \n  .imagePreview {\n    position: relative;\n    height: 200px;\n  }\n  \n  .imagePreview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 4px;\n  }\n  \n  .audioPreview {\n    position: relative;\n    min-height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1rem;\n    background-color: #252525;\n    border-radius: 4px;\n  }\n  \n  .removeButton {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    background-color: rgba(0, 0, 0, 0.5);\n    border: none;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #ffffff;\n  }\n  \n  .removeButton:hover {\n    background-color: #ff4444;\n  }\n  \n  .checkboxLabel {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n  }\n  \n  .checkboxLabel input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    accent-color: #ff4444;\n  }\n  \n  .submitButton {\n    background-color: #ff4444;\n    color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    padding: 1rem 2rem;\n    font-size: 1rem;\n    cursor: pointer;\n    width: 100%;\n    margin-top: 2rem;\n    transition: background-color 0.2s;\n  }\n  \n  .submitButton:hover {\n    background-color: #ff2222;\n  }\n  \n  .select {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #333;\n    border-radius: 4px;\n    background-color: #1e1e1e;\n    font-size: 1rem;\n    color: white;\n  }\n  \n  .select:focus {\n    outline: none;\n    border-color: #ff4444;\n    box-shadow: 0 0 0 2px rgba(255, 68, 68, 0.25);\n  }\n  /* Searchable Select Wrapper */\n.searchableSelect {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.searchableSelect:hover {\n  border-color: #ff3333;\n}\n\n.searchableSelect input {\n  flex-grow: 1;\n  background: transparent;\n  border: none;\n  color: #f0f0f0;\n  font-size: 1rem;\n  outline: none;\n  width: 100%;\n}\n\n.searchableSelect .dropdownArrow {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #ff6666;\n  transition: transform 0.2s ease;\n}\n\n.searchableSelect.open .dropdownArrow {\n  transform: rotate(180deg);\n}\n\n/* Dropdown List */\n.dropdownList {\n background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  margin-top: 5px;\n  list-style: none;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.dropdownItem {\n  padding: 10px 14px;\n  font-size: 1rem;\n  color: #f0f0f0;\n  transition: background 0.2s ease, color 0.2s ease;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background-color: #ff3333;\n  color: #ffffff;\n}\n\n.dropdownItem:empty {\n  color: #888888;\n  text-align: center;\n}\n\n.dropdownList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdownList::-webkit-scrollbar-thumb {\n  background: #ff3333;\n  border-radius: 4px;\n}\n\n.dropdownList::-webkit-scrollbar-track {\n  background: #222222;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddAudios_container__7tw1K`,
	"header": `AddAudios_header__tWNPE`,
	"headerIcon": `AddAudios_headerIcon__LwFyF`,
	"form": `AddAudios_form__ZcF3L`,
	"formGroup": `AddAudios_formGroup__1mdJ-`,
	"imageUploadSection": `AddAudios_imageUploadSection__ksUrr`,
	"imageUpload": `AddAudios_imageUpload__Cx9cD`,
	"audioUpload": `AddAudios_audioUpload__3epvC`,
	"uploadArea": `AddAudios_uploadArea__QcG2-`,
	"uploadPlaceholder": `AddAudios_uploadPlaceholder__0dT7n`,
	"fileInput": `AddAudios_fileInput__uT8Kp`,
	"imagePreview": `AddAudios_imagePreview__Jxy4R`,
	"audioPreview": `AddAudios_audioPreview__y67zQ`,
	"removeButton": `AddAudios_removeButton__jyqLK`,
	"checkboxLabel": `AddAudios_checkboxLabel__ErsyB`,
	"submitButton": `AddAudios_submitButton__EVzg9`,
	"select": `AddAudios_select__vl9J9`,
	"searchableSelect": `AddAudios_searchableSelect__GUWHn`,
	"dropdownArrow": `AddAudios_dropdownArrow__Pky7X`,
	"open": `AddAudios_open__ZmpCF`,
	"dropdownList": `AddAudios_dropdownList__GqyZs`,
	"fadeIn": `AddAudios_fadeIn__Pg284`,
	"dropdownItem": `AddAudios_dropdownItem__T1ydQ`
};
export default ___CSS_LOADER_EXPORT___;
